module.exports = __webpack_public_path__ + "img/c.80c3641d.png";